import { ITrailerStatesEnum } from 'types/graphqlTypes'
import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

// logical xor
const requiredTogether = ({ date, time }: { date: string; time: string }) =>
  (!!date && !!time) || (!date && !time)

export const AddTrailerSchema = yup.object({
  carrier: yup.string().required(REQUIRED_MESSAGE),
  trailerNumber: yup.string().trim().required(REQUIRED_MESSAGE),
  status: yup.string().nullable().required(REQUIRED_MESSAGE),
  shipment: yup.string().when('status', {
    is: ITrailerStatesEnum.assigned_to_shipment,
    then: yup.string().required(REQUIRED_MESSAGE),
  }),
  facility: yup.string().when('status', {
    is: ITrailerStatesEnum.assigned_to_facility,
    then: yup.string().required(REQUIRED_MESSAGE),
  }),
  trailerNotes: yup.string(),
  arrivedAt: yup
    .object({
      date: yup.string().nullable(),
      time: yup.string(),
    })
    .test({
      name: 'required-together',
      message: 'Date and time must be submitted together',
      test: requiredTogether,
    }),
  emptiedAt: yup
    .object({
      date: yup.string().nullable(),
      time: yup.string(),
    })
    .when('status', {
      is: ITrailerStatesEnum.empty_at_delivery,
      then: yup.object({
        time: yup.string().required(REQUIRED_MESSAGE),
        date: yup.string().required(REQUIRED_MESSAGE),
      }),
    }),
})

export type TAddTrailerSchema = yup.InferType<typeof AddTrailerSchema>
